import { IRoutePath } from '@/types/router';

const features = {
  title: 'Our features',
  description: `Orcatec is a flexible platform that is suitable for companies providing field services. We designed our field service management software to meet the diverse needs.`,
  items: [
    { title: 'Scheduling Software', path: IRoutePath.FEATURES_SCHEDULIG },
    { title: 'Estimates', path: IRoutePath.FEATURES_ESTIMATES },
    { title: 'Dispatching', path: IRoutePath.FEATURES_DISPATCHIG },
    { title: 'Invoicing', path: IRoutePath.FEATURES_INVOICING },
    { title: 'Sales Proposal Tool', path: IRoutePath.FEATURES_SALES_PROPOSAL },
    { title: 'Home Service Agreement', path: IRoutePath.FEATURES },
    { title: 'Job Management', path: IRoutePath.FEATURES },
    { title: 'Quoting', path: IRoutePath.FEATURES },
    { title: 'Route Tracking', path: IRoutePath.FEATURES },
    { title: 'Employee GPS Tracking', path: IRoutePath.FEATURES_GPS_TRACKING },
  ],
};

export { features };
